import Button from "./Button"

export type { ButtonProps, StyledButtonProps } from "./Button"
export { IconButton } from "./IconButton"
export type { IconButtonProps } from "./IconButton"

export default Button
